<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : model.pkid ? '编辑' : '新建'"
      width="1100px"
      class="adaptationModal"
      @close="dialogClose()">
    <el-button :disabled="disabled" type="primary" size="mini" @click="$refs.fileModal.open()">添加</el-button>
    <el-table
        v-loading="contentLoading"
        border
        stripe
        :data="model.panVOS"
        style="width: 100%; margin-top: 8px">
      <el-table-column label="文件类型" width="80" align="center" prop="type">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 16">文件夹</span>
          <span v-if="scope.row.type === 128">文件</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="资料名称" width="140" show-overflow-tooltip/>
      <el-table-column prop="fileTypeName" label="资料类型" align="center" width="100"/>
      <el-table-column prop="cascadeNames" label="存放目录" show-overflow-tooltip/>
      <el-table-column prop="roleNames" label="发布对象" show-overflow-tooltip/>
      <el-table-column prop="creatorName" label="提交人" width="80" align="center"/>
      <el-table-column width="120" label="操作" align="center">
        <template slot-scope="scope">
          <el-button :disabled="disabled" type="primary" @click="editHandle(scope.row, scope.$index)">编辑</el-button>
          <el-button :disabled="disabled" type="danger" @click="model.panVOS.splice(scope.$index, 1)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="show && disabled">
      <handle-detail :bill-id="model.pkid" bill-type="25" sequ-id="-1"/>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" type="primary" :loading="submitLoading" @click="submitHandle">确定</el-button>
    </span>
    <fileModal ref="fileModal" @save-success="addDetial"/>
  </el-dialog>
</template>

<script>
  import fileModal from "./FileModal.vue";
  import handleDetail from "@/views/workFlow/HandleDetail.vue";
  export default {
    components: {
      fileModal,
      handleDetail,
    },

    data() {
      return {
        show: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        fileTypeList: [],
        model: {
          pkid: "",
          billNo: "",
          panVOS: [],
        },
        indexMark: "",
        disabled: false,
      };
    },

    methods: {
      open(pkid, mark) {
        this.dialogVisible = true;
        this.model.panVOS = [];
        this.model.pkid = 0;
        this.disabled = mark;
        this.model.pkid = pkid;
        this.$nextTick(() => {
          if (pkid) {
            this.getData(pkid);
          }
        });
      },
      dialogClose() {
        this.model.panVOS = [];
        this.model.pkid = 0;
        this.model.billNo = [];
        this.model = {};
        this.$router.go(0);
      },
      // 获取详情
      getData(pkid) {
        this.contentLoading = true;
        this.$http
          .get("basic", `panPublishProcess/${pkid}`)
          .then((res) => {
            this.model = Object.assign(this.model, res);
            console.log(res);
            this.show = true;
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 添加明细
      addDetial(row) {
        if (this.indexMark || this.indexMark === 0) {
          this.$set(this.model.panVOS, this.indexMark, JSON.parse(row));
        } else {
          this.model.panVOS.push(JSON.parse(row));
        }
      },

      editHandle(row, index) {
        this.indexMark = index;
        this.$refs.fileModal.open(row);
      },

      // 确定
      submitHandle() {
        console.log(this.model);
        this.submitLoading = true;
        this.$http
          .save("basic", "panPublishProcess", this.model)
          .then(() => {
            this.submitLoading = false;
            this.dialogVisible = false;
            this.$emit("save-success");
            if (!this.model.pkid) {
              this.$message.success("添加成功");
            } else {
              this.$message.success("编辑成功");
            }
            this.model = {};
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
    },
  };
</script>
